import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

const ProtectedRoute = ({ allowedUids }) => {
  const { currentUser } = useContext(AuthContext);

  // First, check if the user is logged in at all
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Next, if a list of allowed UIDs is provided, check if the user is in it
  if (allowedUids && !allowedUids.includes(currentUser.uid)) {
    // If the user is not in the allowed list, redirect them to the dashboard
    return <Navigate to="/dashboard" replace />;
  }

  // If all checks pass, render the child route
  return <Outlet />;
};

export default ProtectedRoute;